module.exports = __webpack_public_path__ + "media/images/homes/CustomizeOrderingHours-ebbe8a8cbcd1dfadcaf732eccb7834a3.png";